import React, { useState } from 'react';
import { Button, Modal, Radio } from 'semantic-ui-react';
import { otpMethodOptions } from 'Containers/Auth/constants';
import classNames from 'classnames';

import styles from './SelectOTPMethodModal.less';

interface Props {
  open: boolean;
  onClose: () => void;
  initMethod: number;
  onSave: (otpMethod: number) => void;
}

const SelectOTPMethodModal = ({ open, onClose, initMethod, onSave }: Props) => {
  const [selectedMethod, setSelectedMethod] = useState(initMethod);
  const isActive = (value: number) => value === selectedMethod;

  const handleSave = () => {
    onSave(selectedMethod);
    onClose();
  };

  return (
    <Modal open={open} size="tiny" onClose={onClose} style={{ width: '340px' }}>
      <Modal.Header style={{ borderBottom: 'none' }}>Send OTP to</Modal.Header>
      <Modal.Content style={{ padding: '16px 24px' }}>
        {otpMethodOptions.map(option => (
          <div
            onClick={() => setSelectedMethod(option.value)}
            key={option.value}
            className={classNames(styles.methodOptionWrapper, {
              [styles.active]: isActive(option.value),
            })}>
            <div className={styles.methodName}>
              {option.icon} <span>{option.text}</span>
            </div>
            <Radio checked={isActive(option.value)} className={styles.radio} />
          </div>
        ))}
      </Modal.Content>
      <Modal.Actions style={{ backgroundColor: '#FFFFFF' }}>
        <Button size="small" onClick={onClose}>
          Cancel
        </Button>
        <Button size="small" onClick={handleSave} primary>
          Save
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default SelectOTPMethodModal;
